import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import { FaBarsStaggered } from "react-icons/fa6";
import { Link } from "react-router-dom";
import axios from "axios";
import { IoSearchOutline } from "react-icons/io5";
import Loader from "../../components/Loader";
import { toast } from "react-toastify";
import AdminNav from "./AdminNav";

const FundRequest = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [allFundRequests, setAllFundRequests] = useState([]);
  const [filteredFundRequests, setFilteredFundRequests] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const token = localStorage.getItem("admintoken");

  // Fetch Fund Request data
  useEffect(() => {
    const fetchFundRequestData = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API}/api/v1/fund/get-all-fund-req`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (data?.success) {
          const sortedFundReq = data.subscriptions.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setAllFundRequests(sortedFundReq);
          setFilteredFundRequests(sortedFundReq);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch fund requests");
      } finally {
        setLoading(false);
      }
    };

    fetchFundRequestData();
  }, [token]);

  // Handle Search
  useEffect(() => {
    const searchQuery = searchTerm.trim().toLowerCase();
    const filtered = searchQuery
      ? allFundRequests.filter((request) => {
          const userName = `${request.firstName || ""} ${
            request.surname || ""
          }`.toLowerCase();
          const userEmail = request.email?.toLowerCase() || "";
          const fundName = request.fundId?.name?.toLowerCase() || ""; // Assuming fundId has name
          const className = request.classId?.name?.toLowerCase() || ""; // Assuming classId has name
          const requestDate = new Date(request.createdAt)
            .toLocaleString()
            .toLowerCase();
          const status = getFundStatus(request.status)?.toLowerCase() || "";

          return (
            userName.includes(searchQuery) ||
            userEmail.includes(searchQuery) ||
            fundName.includes(searchQuery) ||
            className.includes(searchQuery) ||
            requestDate.includes(searchQuery) ||
            status.includes(searchQuery)
          );
        })
      : allFundRequests;

    setFilteredFundRequests(filtered);
  }, [searchTerm, allFundRequests]);

  const getFundStatus = (status) => {
    switch (status) {
      case "Pending":
        return "Pending";
      case "Approved":
        return "Approved";
      case "Rejected":
        return "Rejected";
      default:
        return "Unknown";
    }
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "Pending":
        return "status-pending";
      case "Approved":
        return "status-approved";
      case "Rejected":
        return "status-rejected";
      default:
        return "";
    }
  };

  return (
    <div className="wrapper d-flex align-items-stretch">
      {loading && <Loader />}
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <div id="content" className="px-2">
        <button
          type="button"
          id="openSidebar"
          onClick={toggleSidebar}
          className="bars-btn"
        >
          <FaBarsStaggered />
        </button>
        <AdminNav />
        <h3 className="b-clr">Fund Joining Requests</h3>
        <div className="search-add-main">
          <div className="search-main">
            <input
              type="text"
              className="search-inp"
              placeholder="Search by name, email, fund, class, date or status..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <div className="search-icon">
              <IoSearchOutline />
            </div>
          </div>
        </div>

        <div className="tbl-main">
          <table className="simple-table">
            <thead>
              <tr>
                <th>REQUEST DATE</th>
                <th>INVESTOR NAME</th>
                <th>EMAIL</th>
                <th>FUND</th>
                <th>CLASS</th>
                <th>SUBSCRIPTION AMOUNT</th>
                <th>STATUS</th>
                <th>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {filteredFundRequests.length > 0 ? (
                filteredFundRequests.map((request) => (
                  <tr key={request._id}>
                    <td>{new Date(request.createdAt).toLocaleString()} </td>

                    <td>
                      {`${request.firstName || ""} ${
                        request.surname || ""
                      }`.trim()}
                    </td>
                    <td>{request.email}</td>
                    <td>{request.fundId?.name || "N/A"}</td>
                    <td>{request.classId?.class || "N/A"}</td>
                    <td>
                      {request.subscriptionSum} {request.subscriptionCurrency}
                    </td>
                    <td>
                      <span
                        className={`status-badge ${getStatusClass(
                          request.status
                        )}`}
                      >
                        {getFundStatus(request.status)}
                      </span>
                    </td>
                    <td>
                      <Link
                        className="btn btn-primary"
                        to={`/dashboard/admin/fund-request-details/${request._id}`}
                      >
                        View
                      </Link>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8">No fund joining requests found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default FundRequest;
